require('../js/scripts.js')
import '../sass/style.scss'
import '../sass/editor.scss'